import { storeToRefs } from "pinia";
import { useTrainingPrefillStore } from "~/store/copilot/training-prefill.store";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import { TrainingPrefillFieldEnum } from "~/utils/enums/training-prefill.enums";

/**
 * Drops a field's ✦ marker the moment the admin edits it: the value is theirs from then on.
 * Registered once by the training modal, so one total map covers the fields of every step.
 */
export const useTrainingPrefillWatchers = () => {
  const prefillStore = useTrainingPrefillStore();
  const { training } = storeToRefs(useCreateTrainingStore());

  /** Value behind each field the assistant can pre-fill. */
  const AI_FIELD_SOURCES: Record<TrainingPrefillFieldEnum, () => unknown> = {
    [TrainingPrefillFieldEnum.TRAINING_PARTNER]: () => training.value.general.trainingPartner?.name,
    [TrainingPrefillFieldEnum.TITLE]: () => training.value.general.title,
    [TrainingPrefillFieldEnum.EXTERNAL_URL]: () => training.value.general.externalUrl,
    [TrainingPrefillFieldEnum.DURATION_HOURS]: () => training.value.general.durationHours,
    [TrainingPrefillFieldEnum.DURATION_DAYS]: () => training.value.general.durationDays,
    [TrainingPrefillFieldEnum.TARGET_AUDIENCE]: () => training.value.content.targetAudience,
    // A normalized string rather than the array: the content step reassigns the list on mount and
    // "Ajouter un objectif" pushes an empty entry — neither is an edit of the assistant's goals.
    [TrainingPrefillFieldEnum.GOALS]: () => (training.value.content.goals ?? []).filter(Boolean).join("\n"),
    [TrainingPrefillFieldEnum.PROGRAM]: () => training.value.content.program,
    [TrainingPrefillFieldEnum.FORMAT]: () => training.value.general.format,
    [TrainingPrefillFieldEnum.PRICE_INTER_EXCL_TAX]: () => training.value.sessionItems.individual.priceExclTax,
    [TrainingPrefillFieldEnum.PRICE_INTRA_EXCL_TAX]: () => training.value.sessionItems.group.priceExclTax,
  };

  for (const [field, readValue] of Object.entries(AI_FIELD_SOURCES)) {
    watch(readValue, () => prefillStore.clearField(field as TrainingPrefillFieldEnum));
  }
};
